import React, { Fragment } from 'react';

export const MAIN_TEXT_RUN = [
  { text: 'New Arrivals', className: 'header-freaks-store__main-2025__text-run__new-arrivals' },
  { text: 'In-store', className: 'header-freaks-store__main-2025__text-run__in-store' },
  { text: 'New Arrivals', className: 'header-freaks-store__main-2025__text-run__new-arrivals' },
  { text: 'Online', className: 'header-freaks-store__main-2025__text-run__online' },
];

export const MAIN_NAVS = [
  {
    id: 'FK1003G-5S',
    title: (
      <Fragment>
        Photochromic
        <br />
        Sunglasses
      </Fragment>
    ),
    alt: 'photochromic sunglasses metal frame',
    altGlasses: 'FK1003G-5S',
    frame: 'Metal Frame',
    price: 'S$78',
  },
  {
    id: 'FK2005B-5S',
    title: (
      <Fragment>
        Photochromic
        <br />
        Sunglasses
      </Fragment>
    ),
    alt: 'photochromic sunglasses plastic frame',
    altGlasses: 'FK2005B-5S',
    frame: 'Plastic Frame',
    price: 'S$78',
  },
  {
    id: 'FK2004N-5S',
    title: (
      <Fragment>
        Folding
        <br />
        Sunglasses
      </Fragment>
    ),
    alt: 'folding sunglasses',
    altGlasses: 'FK2004N-5S',
    frame: null,
    price: 'S$78',
  },
  {
    id: 'FK2003N-5S',
    title: (
      <Fragment>
        Polarised
        <br />
        Sunglasses
      </Fragment>
    ),
    alt: 'polarised sunglasses',
    altGlasses: 'FK2003N-5S',
    frame: null,
    price: 'S$78',
  },
];

export const STYLES = {
  photochromicMetal: {
    id: 'FK1003G-5S',
    no: (
      <Fragment>
        No.<strong>01</strong>
      </Fragment>
    ),
    title: (
      <Fragment>
        Photochromic
        <br />
        Sunglasses
      </Fragment>
    ),
    frame: 'Metal Frame',
    desc: `These Boston-style photochromic sunglasses are crafted primarily from sleek metal, featuring lenses that adjust their color based on UV light exposure. Designed for all-day comfort, they function as clear glasses indoors and stylish sunglasses outdoors. The frame is coated with glossy enamel in a pot-belly style, adding a three-dimensional flair. Light and cheerful, the frame maintains its charm even as the lenses change color. Subtle engravings on the frame give it an accessory-like elegance, perfect for any occasion.`,
    imgPath: '/photochromic/metal',
    alt: {
      main: 'photochromic sunglasses metal frame',
      sub: 'FK1003G-5S details',
    },
    product: {
      number: 'FK1003G-5S',
      price: 'S$78',
      colors: ['Black', 'Greige', 'Brown'],
      limit: 9,
      startIndex: 0,
      specifications: [
        {
          visibleLightTransmittance: '15.57%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
        {
          visibleLightTransmittance: '16.12%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
        {
          visibleLightTransmittance: '12.06%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
      ],
    },
    remark: 'UV and visible light transmittance at their darkest state',
  },
  photochromicPlastic: {
    id: 'FK2005B-5S',
    no: (
      <Fragment>
        No.<strong>02</strong>
      </Fragment>
    ),
    title: (
      <Fragment>
        Photochromic
        <br />
        Sunglasses
      </Fragment>
    ),
    frame: 'Plastic Frame',
    desc: `The Wellington photochromic sunglasses make their return in the second collection, featuring lenses that adapt to changing UV light. Enjoy the convenience of versatile eyewear that seamlessly transitions from indoor to outdoor use. The clip-on sunglasses are clear indoors and transform into stylish tinted lenses outdoors. Subtle diamond engravings on the inner temples evoke traditional Native American patterns, creating a unique, behind-the-scenes accent visible only when the clip-on is worn. This thoughtful design combines fashion with functionality.`,
    imgPath: '/photochromic/plastic',
    alt: {
      main: 'photochromic sunglasses plastic frame',
      sub: 'FK2005B-5S details',
    },
    product: {
      number: 'FK2005B-5S',
      price: 'S$78',
      colors: ['Black', 'Brown Demi', 'Clear Grey'],
      limit: 8,
      startIndex: 0,
      specifications: [
        {
          visibleLightTransmittance: '12.06%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
        {
          visibleLightTransmittance: '12.09%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
        {
          visibleLightTransmittance: '15.57%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
      ],
    },
    remark: 'UV and visible light transmittance at their darkest state',
  },
  folding: {
    id: 'FK2004N-5S',
    no: (
      <Fragment>
        No.<strong>03</strong>
      </Fragment>
    ),
    title: (
      <Fragment>
        Folding
        <br />
        Sunglasses
      </Fragment>
    ),
    frame: null,
    desc: `Perfect for the upcoming holiday season, these Crown Panto style sunglasses are foldable and compact, easily fitting in the palm of your hand. The frame features a sleek, straight-across top, paired with a distinctive rounded, inverted triangle shape at the bottom. The design is elevated with tinted lenses, adding a touch of fashion-forward flair.`,
    imgPath: '/folding',
    alt: {
      main: 'folding sunglasses',
      sub: 'FK2004N-5S details',
    },
    product: {
      number: 'FK2004N-5S',
      price: 'S$78',
      colors: ['Matte Black', 'Brown', 'Clear'],
      limit: 7,
      startIndex: 1,
      specifications: [
        {
          visibleLightTransmittance: '15.25%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
        {
          visibleLightTransmittance: '16.43%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
        {
          visibleLightTransmittance: '14.63%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
      ],
    },
    remark: null,
  },
  polarised: {
    id: 'FK2003N-5S',
    no: (
      <Fragment>
        No.<strong>04</strong>
      </Fragment>
    ),
    title: (
      <Fragment>
        Polarised
        <br />
        Sunglasses
      </Fragment>
    ),
    frame: null,
    desc: `The Wellington style, ideal for outdoor adventures, features polarized lenses that block glare from both the sun and water. This classic design is updated with sporty straight temples, rubberized on the inside for a secure, slip-free fit. The longer temples offer a comfortable, snug embrace around the head. Lightweight and practical, this style is perfect for any active pursuit.`,
    imgPath: '/polarized',
    previewLimit: 3,
    alt: {
      main: 'polarized sunglasses',
      sub: 'FK2003N-5S details',
    },
    product: {
      number: 'FK2003N-5S',
      price: 'S$78',
      colors: ['Matte Black', 'Brown Demi', 'Clear'],
      limit: 4,
      startIndex: 1,
      specifications: [
        {
          visibleLightTransmittance: '9.78%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
        {
          visibleLightTransmittance: '15.43%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
        {
          visibleLightTransmittance: '11.07%',
          uvTransmittance: 'Less than 1%',
          lensMaterial: 'Plastic',
        },
      ],
      remark: null,
    },
  },
};

export const CASE = {
  title: (
    <Fragment>
      Original Case &amp;
      <br />
      Cleaning Cloth Set
      <br />
      <small>In this bundle</small>
    </Fragment>
  ),
  alt: 'freaks store original case and cleaning cloth set 2025',
  list: [
    {
      title: null,
      desc: <Fragment>Every frame in the collection is paired with a waterproof PVC spectacle case and a large, vibrantly designed spectacle cloth, reflecting the signature style of FREAK’<span>S</span> STORE.</Fragment>,
    },
    {
      title: 'PVC Sunglasses Case',
      desc: `Crafted from waterproof PVC, this versatile case is perfect for keeping your sunglasses safe on the go. With its spacious base, it also serves as a pouch for small items. The adjustable strap allows you to wear it as a sling bag, with a design that keeps excess length neatly hidden for a clean, streamlined look.`,
    },
    {
      title: 'Large Spectacle Cloth',
      desc: <Fragment>An exclusive collaboration piece, this spectacle cloth is double the size of the standard OWNDAYS cloth, making it easier to wipe away fingerprints and smudges from your sunglasses, especially with frequent use. It boasts a vibrant design, true to the signature style of FREAK’<span>S</span> STORE.</Fragment>,
    },
  ],
};

export const CONDITIONS = [
  'Not valid in combination with any discounts, promotions, offers, or privileges.',
  'No cancellations, refunds, exchanges, or changes to order details once the order is placed.',
  'Resale and transfer of products are strictly prohibited.',
  'Delivery is available within Singapore only.',
  'Optional lens upgrades are available at an additional charge.',
  'The product does not come with a warranty, except for the lens, which is covered under warranty if the product is fitted with prescription or optional lenses.',
];

export const ABOUT = {
  desc: `Driven by the desire to bring the richness and excitement of American culture to Japan, the brand was founded in 1986. Since then, it has curated not just clothing, but also culture, art, and all the things the team genuinely loves. As true 'FREAKS'—enthusiastic explorers of life—they offer a select shop experience that inspires a vibrant, authentic lifestyle.`,
  link: {
    title: (
      <>
        FREAK’<span>S</span> STORE Official Website
      </>
    ),
    url: 'https://www.daytona-park.com/shop/freaks_store',
  },
};

export const SHARES = [
  {
    link: 'https://www.facebook.com/sharer/sharer.php?u=https://www.owndays.com/sg/en/news/freaks-store',
    className: 'fa-facebook',
  },
  {
    link: 'whatsapp://send?text=https://www.owndays.com/sg/en/news/freaks-store',
    className: 'fa-whatsapp',
  },
];
